import React from 'react';

import { bindBotDatasets } from '@mygpt/app/apis';

export const useBotDatasetMethod = () => {
  const [loading, setLoading] = React.useState(false);

  const bind = React.useCallback(async (params: Parameters<typeof bindBotDatasets>[0]) => {
    setLoading(true);

    return bindBotDatasets(params).finally(() => {
      setLoading(false);
    });
  }, []);

  return {
    loading,
    botDatasetBindOrUnbind: bind,
  };
};
